module.exports = __webpack_public_path__ + "bs.30bbf0ec26eeb02fbfa2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bs.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bs.svg
// module chunks = styles